import { parse, isValid } from "date-fns";

import { CalendarDate, parseDate as parseCalendarDate } from "@/ui";

export const fromApiDate = (apiDate: string): Date => {
  const date = fromApiDateNullable(apiDate);

  if (!date) {
    throw new Error(`Could not parse date: ${apiDate}`);
  }

  return date;
};

export const fromApiCalendarDateNullable = (
  apiDate: string | null | undefined
): CalendarDate | null => {
  if (!apiDate) return null;
  try {
    return parseCalendarDate(apiDate.split("T")[0]);
  } catch (error) {
    console.error(`Could not parse date: ${apiDate}`, error);
    return null;
  }
};

export const fromApiDateNullable = (apiDate: string | null | undefined): Date | null => {
  if (!apiDate) return null;
  const date = parseDate(apiDate);
  return isValid(date) ? date : null;
};

const parseDate = (apiDate: string): Date | null => {
  // Check for different date formats using date-fns
  if (apiDate.includes("/") && apiDate.split("/")[0].length <= 2) {
    // Parse DD/MM/YYYY format (e.g., 31/03/2021)
    return parse(apiDate, "dd/MM/yyyy", new Date());
  } else if (apiDate.includes(".") && apiDate.split(".")[0].length <= 2) {
    // Parse DD.MM.YYYY format (e.g., 16.10.2000)
    return parse(apiDate, "dd.MM.yyyy", new Date());
  } else if (apiDate.includes("-") && apiDate.split("-")[0].length <= 2) {
    // Parse DD-MM-YYYY format (contains dashes and starts with day)
    return parse(apiDate, "dd-MM-yyyy", new Date());
  } else {
    // Try ISO and other standard formats
    return new Date(apiDate);
  }
};
